import { Typography } from '@compass/components'

import { IdentificationUrlKeys } from '../../../types'
import { visitFilterLabelMap } from '../../../utils/const'
import { CellAction } from './CellAction'
import { columnHelper, isMobile } from './columnHelper'
import { NotApplicable, Unavailable } from './MissingData'

const key = IdentificationUrlKeys.ActiveCall
const label = visitFilterLabelMap[key]

export const activeCallColumn = () =>
  columnHelper.display({
    id: 'activeCall',
    header: 'Active Call',
    cell: ({ row }) => {
      if (!isMobile(row.original)) {
        return <NotApplicable />
      }

      const result = row.original.active_call

      if (result == null) {
        return <Unavailable />
      }

      return (
        <CellAction search={(old) => ({ ...old, [key]: result })} field={label}>
          <Typography className={result ? 'text-red-800' : ''}>{result ? 'Yes' : 'No'}</Typography>
        </CellAction>
      )
    },
  })
